module.exports = __webpack_public_path__ + "img/w-calendar_hands.1452a741.png";